import UserAdTypes from './constants'

export const loadUsers = (formData) => {
  return {
    type: UserAdTypes.LOAD_USERS,
    payload: formData
  }
}
export const setUsers = (data) => {
  return {
    type: UserAdTypes.SET_USERS,
    payload: data
  }
}
export const adminUserRemoveItemRequest = function adminUserRemoveItemRequest (requestData) {  
  return {
    type: UserAdTypes.ITEM_REMOVE_REQUESTING,
    payload: requestData
  }
}

export const adminUserItemRemoveSuccess = function adminUserItemRemoveSuccess (message) {  
  return {
    type: UserAdTypes.ITEM_REMOVE_SUCCESS,
    payload: message
  }
}

export const adminUserItemRemoveError = function adminUserItemRemoveError (error) {  
  return {
    type: UserAdTypes.ITEM_REMOVE_ERROR,
    payload: error
  }
}

export const adminUserSetDataForUser = (data) => {  
  return {
    type: UserAdTypes.SET_DATA_TO_USER,
    payload: data
  }
}

export const adminUserSetMessage = function adminUserSetMessage (message) {  
  return {
    type: UserAdTypes.SET_MESSAGE,
    payload: message
  }
}

export const resetError = () => {  
  return {
    type: UserAdTypes.RESET_ERROR,
  }
}

export const adminUserSetError = (error) => {  
  return {
    type: UserAdTypes.SET_ERROR,
    payload: error
  }
}

export const adminUserSetErrors = (error) => {  
  return {
    type: UserAdTypes.SET_FORM_MESSAGES,
    payload: error
  }
}

export const userAdListRequest = function userAdListRequest (formData) {  
  return {
    type: UserAdTypes.LIST_REQUESTING,
    payload: formData
  }
}

export const userAdListSuccess = function userAdListSuccess (data) {  
  return {
    type: UserAdTypes.LIST_SUCCESS,
    data
  }
}

export const userAdListError = function userAdListError (error) {  
  return {
    type: UserAdTypes.LIST_ERROR,
    error
  }
}

export const adminUserItemRequest = function adminUserItemRequest (formData, callback) {  
  return {
    type: UserAdTypes.ITEM_REQUESTING,
    payload: formData
  }
}

export const adminUserItemSuccess = function adminUserItemSuccess (data) {  

  return {
    type: UserAdTypes.ITEM_SUCCESS,
    data : data
  }
}
export const adminUserSetDataForItem = function adminUserSetDataForItem (name, data) { 
  return {
    type: UserAdTypes.SET_DATA_TO_PROPS,
    payload: {name, data}
  }
}

export const adminUserItemError = function adminUserItemError (error) {  
  return {
    type: UserAdTypes.ITEM_ERROR,
    error
  }
}
export const adminUserItemAddRequest = function adminUserItemAddRequest (formData) {  
  return {
    type: UserAdTypes.ITEM_ADD_REQUESTING,
    payload: formData
  }
}

export const adminUserItemAddSuccess = function adminUserItemAddSuccess (responseData) {  
  return {
    type: UserAdTypes.ITEM_ADD_SUCCESS,
    data: responseData.data,
    message: responseData.message
  }
}

export const adminUserItemAddError = function adminUserItemAddError (error) {  
  return {
    type: UserAdTypes.ITEM_ADD_ERROR,
    error
  }
}
export const adminUserItemUpdateRequest = function adminUserItemUpdateRequest (formData) {  
  return {
    type: UserAdTypes.ITEM_UPDATE_REQUESTING,
    payload: formData
  }
}

export const adminUserItemUpdateSuccess = function adminUserItemUpdateSuccess (responseData) {  
  return {
    type: UserAdTypes.ITEM_UPDATE_SUCCESS,
    data: responseData.data,
    message: responseData.message
  }
}

export const adminUserItemUpdateError = function adminUserItemUpdateError (error) {  
  return {
    type: UserAdTypes.ITEM_UPDATE_ERROR,
    error
  }
}

export const adminUserResetData = function adminUserResetData () {  
  return {
    type: UserAdTypes.RESET_DATA,
  }
}


// WEBPACK FOOTER //
// ./src/views/Admin/UserAd/actions.js